"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findAtomValue = findAtomValue;
exports.makeValueFinder = makeValueFinder;
exports.makeRuleBuilder = makeRuleBuilder;
exports.buildFunctionAggregateRule = buildFunctionAggregateRule;
exports.buildAggregateRule = buildAggregateRule;
exports.buildStreamingRule = buildStreamingRule;
exports.buildRule = buildRule;
exports.reflectorRule = exports.defaultContinueProcessingSubRules = exports.defaultPostProcessor = exports.ALLOW_UNDEF = void 0;

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));

var ALLOW_UNDEF = true;
exports.ALLOW_UNDEF = ALLOW_UNDEF;

var defaultPostProcessor = function defaultPostProcessor(r) {
  return r;
};

exports.defaultPostProcessor = defaultPostProcessor;

var defaultContinueProcessingSubRules = function defaultContinueProcessingSubRules() {
  return true;
};

exports.defaultContinueProcessingSubRules = defaultContinueProcessingSubRules;

var reflectorRule = function reflectorRule() {
  return function (v) {
    return v;
  };
};

exports.reflectorRule = reflectorRule;

function findAtomValue(atomId, values) {
  return values.find(function (val) {
    return val.id === atomId;
  });
}

function makeValueFinder(values, rule) {
  var finder = function finder(atomId) {
    var allowUndef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var atomValue = findAtomValue(atomId, values);

    if (atomValue) {
      return atomValue.value;
    } else {
      if (allowUndef) {
        return undefined;
      } else {
        throw new Error("Could not find value for ".concat(atomId));
      }
    }
  };

  finder.rule = rule;
  return finder;
}

function makeRuleBuilder(ruleBuilderDispatch) {
  return function (rule) {
    var _rule$values$ = rule.values[0],
        id = _rule$values$.id,
        value = _rule$values$.value;

    if (ruleBuilderDispatch[id] && typeof ruleBuilderDispatch[id] === "function") {
      return ruleBuilderDispatch[id];
    } else if (ruleBuilderDispatch[id] && ruleBuilderDispatch[id][value]) {
      return ruleBuilderDispatch[id][value];
    } else {
      throw new Error("Cannot get rule builder for ".concat(id, "/").concat(value));
    }
  };
}

function buildFunctionAggregateRule(getRuleBuilderForRule, rule) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$postProcessor = _ref.postProcessor,
      postProcessor = _ref$postProcessor === void 0 ? defaultPostProcessor : _ref$postProcessor;

  var ruleFunc = getRuleBuilderForRule(rule)(makeValueFinder(rule.values, rule));
  var subRuleFuncs = (rule.subRules || []).map(function (subRule) {
    return (// build a rule for each subrule, and keep it.
      buildRule(getRuleBuilderForRule, subRule, {
        isSubRule: true,
        postProcessor: postProcessor
      })
    );
  });

  var aggregateRuleFunc = function aggregateRuleFunc(val, obj) {
    return postProcessor(ruleFunc(val, obj, subRuleFuncs));
  };

  return aggregateRuleFunc;
}

function buildAggregateRule(getRuleBuilderForRule, rule) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref2$postProcessor = _ref2.postProcessor,
      postProcessor = _ref2$postProcessor === void 0 ? defaultPostProcessor : _ref2$postProcessor;

  var ruleFunc = getRuleBuilderForRule(rule)(makeValueFinder(rule.values, rule));

  var aggregateRuleFunc = function aggregateRuleFunc(val) {
    var subRuleValues = rule.subRules.map(function (subRule) {
      return (// build a rule for each subrule, and call it.
        buildRule(getRuleBuilderForRule, subRule, {
          isSubRule: true,
          postProcessor: postProcessor
        })(val, obj)
      );
    });
    return postProcessor(ruleFunc(val, obj, subRuleValues));
  };

  return aggregateRuleFunc;
}

function buildStreamingRule(getRuleBuilderForRule, rule) {
  var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref3$continueProcess = _ref3.continueProcessingSubRules,
      continueProcessingSubRules = _ref3$continueProcess === void 0 ? defaultContinueProcessingSubRules : _ref3$continueProcess,
      _ref3$postProcessor = _ref3.postProcessor,
      postProcessor = _ref3$postProcessor === void 0 ? defaultPostProcessor : _ref3$postProcessor;

  var ruleFunc = getRuleBuilderForRule(rule)(makeValueFinder(rule.values, rule));
  var subRuleFuncs = rule.subRules.map(function (subRule) {
    return buildRule(getRuleBuilderForRule, subRule, {
      isSubRule: true,
      continueProcessingSubRules: continueProcessingSubRules
    });
  });

  var streamingRuleFunc = function streamingRuleFunc(obj) {
    var lastVal = ruleFunc(obj);

    var _iterator = (0, _createForOfIteratorHelper2.default)(subRuleFuncs),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var subRuleFunc = _step.value;

        if (continueProcessingSubRules(lastVal)) {
          lastVal = subRuleFunc(lastVal, obj);
        } else {
          break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return lastVal;
  };

  return postProcessor(streamingRuleFunc);
}

function buildRule(getRuleBuilderForRule, rule) {
  var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref4$isSubRule = _ref4.isSubRule,
      isSubRule = _ref4$isSubRule === void 0 ? false : _ref4$isSubRule,
      _ref4$continueProcess = _ref4.continueProcessingSubRules,
      continueProcessingSubRules = _ref4$continueProcess === void 0 ? defaultContinueProcessingSubRules : _ref4$continueProcess,
      _ref4$postProcessor = _ref4.postProcessor,
      postProcessor = _ref4$postProcessor === void 0 ? defaultPostProcessor : _ref4$postProcessor;

  // if there are no subrules, then we're done. Just hand back this ruleFunc.
  if (!rule.subRules.length) {
    return postProcessor(getRuleBuilderForRule(rule)(makeValueFinder(rule.values, rule)), isSubRule);
  } // if the subRuleType is stream, then we treat the rules as an array. Starts with the
  // parent rule, and then each subRule in sequence. We call each ruleFunc and hand the results
  // through to the previous one.


  if (rule.subRuleType === "stream") {
    return buildStreamingRule(getRuleBuilderForRule, rule, {
      continueProcessingSubRules: continueProcessingSubRules,
      postProcessor: postProcessor
    });
  } // if the subRuleType is aggregate, then we want to collect all of the subRule results together
  // and hand them into the parent as an argument.
  else if (rule.subRuleType === "aggregate") {
      return postProcessor(buildAggregateRule(getRuleBuilderForRule, rule));
    } else if (rule.subRuleType === "function-aggregate") {
      return postProcessor(buildFunctionAggregateRule(getRuleBuilderForRule, rule));
    } // and finally, if we don't recognize the subRuleType - toss an error.


  throw new Error("Cannot build rule: has subRules, but type is ".concat(rule.subRuleType));
}